import React from 'react';
import UnifiedResetSuccess from '@components/UnifiedResetSuccess';

const ResetSuccess: React.FC = () => {
  return <UnifiedResetSuccess theme="light" />;
};

export default ResetSuccess;
